import React from 'react';


export default function Loading() {
    return <><div className="d-flex align-items-center">
    <strong>Laddar...</strong>
    <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
  </div></>;
}
